module.exports = __webpack_public_path__ + "img/ecowas.54e08ce4.png";